import { Modal } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { AppCopyText } from 'components/ui';
import { useStores } from 'index';

type Props = {
    ticketUrl: string;
};

const CreateTicketReponseModal = observer(({ ticketUrl: ticketUrl }: Props) => {
    const { t } = useTranslation();

    const { userDiagnosticStore } = useStores();

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(ticketUrl);
        } finally {
            userDiagnosticStore.resetTicketResponse()
        }
    };

    return (
        <Modal
            title={t('UserDiagnostics.CreateTicket.Title')}
            open={userDiagnosticStore.hasTicketResponse}
            onClose={() => { userDiagnosticStore.resetTicketResponse() }}
            confirmBtn={{ label: t('UserDiagnostics.Action.CopyUrl'), onClick: () => handleCopy() }}
            cancelBtn={{ label: t('close'), onClick: () => userDiagnosticStore.resetTicketResponse() }}
            style={{ zIndex: 2000 }}
        >
            <div className='d-flex justify-content-between align-items-center w-100'>
                <p data-test={`systemID-cell-text`} className='mb-0 overflow-ellipsis' title={ticketUrl}>
                    {ticketUrl}
                </p>
                <AppCopyText className='ml-1 ' text={ticketUrl} />
            </div>
        </Modal>
    );
});

export default CreateTicketReponseModal;
